class CartDrawer extends HTMLElement{constructor(){super(),this.addEventListener("keyup",e=>e.code==="Escape"&&this.close()),this.querySelector("#CartDrawer-Overlay").addEventListener("click",this.close.bind(this)),this.setHeaderCartIconAccessibility()}setHeaderCartIconAccessibility(){const e=document.querySelector("#cart-icon-bubble");e&&(e.setAttribute("role","button"),e.setAttribute("aria-haspopup","dialog"),e.addEventListener("click",t=>{t.preventDefault(),this.open(e)}),e.addEventListener("keydown",t=>{t.code.toUpperCase()==="SPACE"&&(t.preventDefault(),this.open(e))}))}open(e){e&&this.setActiveElement(e),setTimeout(()=>{this.classList.add("animate","active")}),this.addEventListener("transitionend",()=>{const t=this.classList.contains("is-empty")?this.querySelector(".drawer__inner-empty"):document.getElementById("CartDrawer"),s=this.querySelector(".drawer__inner")||this.querySelector(".bcw-drawer__close");trapFocus(t,s)},{once:!0}),document.body.classList.add("overflow-hidden")}close(){this.classList.remove("active"),removeTrapFocus(this.activeElement),document.body.classList.remove("overflow-hidden")}renderContents(e){typeof e.item_count=="number"&&this.classList.toggle("is-empty",e.item_count===0),this.productId=e.id;const t=(this.querySelector(".bcw-drawer__progress-status")||{}).textContent||"",s=Array.from(this.querySelectorAll(".bcw-drawer__progress-fill")).map(n=>n.style.width),r=Array.from(this.querySelectorAll("[data-milestone]")).map(n=>n.querySelector(".bcw-drawer__milestone")?.classList.contains("bcw-drawer__milestone--reached"));this.getSectionsToRender().forEach(n=>{const l=n.selector?document.querySelector(n.selector):document.getElementById(n.id);l&&(l.innerHTML=this.getSectionInnerHTML(e.sections[n.id],n.selector))});const i=this.querySelector(".bcw-drawer__progress-status");i&&t&&(i.textContent=t),this.querySelectorAll(".bcw-drawer__progress-fill").forEach((n,l)=>{const d=s[l];d!=null&&(n.style.transition="none",n.style.width=d,requestAnimationFrame(()=>{n.style.transition=""}))}),this.querySelectorAll("[data-milestone]").forEach((n,l)=>{const d=n.querySelector(".bcw-drawer__milestone");d&&typeof r[l]=="boolean"&&d.classList.toggle("bcw-drawer__milestone--reached",r[l])}),setTimeout(()=>{this.querySelector("#CartDrawer-Overlay").addEventListener("click",this.close.bind(this)),this.open();const n=this.querySelector("bcw-cart-upsells");n&&n.refresh(),this.syncFreeGift(),this.updateProgressBar()});const a=e.item_count;typeof a=="number"&&setTimeout(()=>this._refreshIfCartDiverged(a),1500)}async _refreshIfCartDiverged(e){try{const t=await fetch(`${window.routes.cart_url}.js`).then(a=>a.json());if(t.item_count===e)return;const r=await(await fetch(`${window.routes.cart_url}?section_id=cart-drawer`)).text(),o=new DOMParser().parseFromString(r,"text/html").querySelector("#CartDrawer"),c=document.querySelector("#CartDrawer");o&&c&&(c.innerHTML=o.innerHTML),this.classList.toggle("is-empty",t.item_count===0),this.syncFreeGift(),this.updateProgressBar()}catch(t){console.error("BCW drawer refresh:",t)}}connectedCallback(){setTimeout(()=>{this.syncFreeGift(),this.updateProgressBar()}),typeof subscribe=="function"&&typeof PUB_SUB_EVENTS<"u"&&(this._cartUpdateUnsub=subscribe(PUB_SUB_EVENTS.cartUpdate,()=>{this.syncFreeGift(),this.updateProgressBar()}))}async updateProgressBar(){const e=parseInt(this.dataset.shippingThreshold||"0",10),t=parseInt(this.dataset.giftThreshold||"0",10),s=parseInt(this.dataset.gift2Threshold||"0",10);if(!(!e&&!t&&!s))try{const r=await fetch(`${window.routes.cart_url}.js`).then(n=>n.json()),i=parseFloat(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.rate||"1"),o=e*i,c=t*i,a=s*i;this._updateSegment("shipping",0,o,r.total_price),this._updateSegment("gift",o,c,r.total_price),this._updateSegment("gift2",c,a,r.total_price),this._updateStatus(r.total_price,[{threshold:o,label:this.dataset.shippingLabel||""},{threshold:c,label:this.dataset.giftLabel||""},{threshold:a,label:this.dataset.gift2Label||""}])}catch(r){console.error("BCW progress bar:",r)}}_updateStatus(e,t){const s=this.querySelector(".bcw-drawer__progress-status");if(!s)return;const r=this.dataset.statusTemplate||"Spend %amount% more for %reward%",i=this.dataset.statusAllUnlocked||"You've unlocked all rewards!";for(const o of t)if(o.threshold>0&&e<o.threshold){s.textContent=r.replace("%amount%",this._formatMoney(o.threshold-e)).replace("%reward%",o.label);return}s.textContent=i}_formatMoney(e){const t=window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active;if(t)try{return new Intl.NumberFormat(document.documentElement.lang||"en",{style:"currency",currency:t}).format(e/100)}catch{}return(e/100).toFixed(2)}_updateSegment(e,t,s,r){const i=this.querySelector(`[data-milestone="${e}"]`);if(!i)return;const o=i.querySelector(".bcw-drawer__progress-fill"),c=i.querySelector(".bcw-drawer__milestone");let a,n;if(s>0){n=r>=s;const l=t>0&&t<s?t:0;n?a=100:r<=l?a=0:a=(r-l)*100/(s-l)}else n=!0,a=100;o&&(o.style.width=`${a}%`),c&&c.classList.toggle("bcw-drawer__milestone--reached",n)}disconnectedCallback(){this._cartUpdateUnsub&&this._cartUpdateUnsub()}_giftConfigs(){const e=[],t=parseInt(this.dataset.giftVariantId,10);t&&e.push({variantId:t,threshold:parseInt(this.dataset.giftThreshold||"0",10),tag:"milestone_2"});const s=parseInt(this.dataset.gift2VariantId,10);return s&&e.push({variantId:s,threshold:parseInt(this.dataset.gift2Threshold||"0",10),tag:"milestone_3"}),e}async syncFreeGift(){if(this._giftSyncing)return;const e=this._giftConfigs();if(e.length){this._giftSyncing=!0;try{const t=await fetch(`${window.routes.cart_url}.js`).then(r=>r.json());if(t.items.length>0&&t.total_price===0){await this._clearCart();return}const s=parseFloat(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.rate||"1");for(const r of e){const i=t.items.find(a=>a.variant_id===r.variantId),o=r.threshold*s,c=r.threshold>0?t.total_price>=o:!0;if(c&&!i&&t.item_count>0){await this._addGift(r.variantId,r.tag);return}else if(!c&&i){await this._removeGift(i.key);return}else if(c&&i&&i.quantity>1){await this._setGiftQty(i.key,1);return}}}catch(t){console.error("BCW gift sync:",t)}finally{this._giftSyncing=!1}}}async _addGift(e,t="milestone_2"){const r=await(await fetch(window.routes.cart_add_url,{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({id:e,quantity:1,properties:{_bcw_gift:t},sections:["cart-drawer","cart-icon-bubble"],sections_url:window.location.pathname})})).json();r.status!==422&&this.renderContents(r)}async _setGiftQty(e,t){const r=await(await fetch(window.routes.cart_change_url,{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({id:e,quantity:t,sections:["cart-drawer","cart-icon-bubble"],sections_url:window.location.pathname})})).json();this.renderContents(r)}async _removeGift(e){const s=await(await fetch(window.routes.cart_change_url,{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({id:e,quantity:0,sections:["cart-drawer","cart-icon-bubble"],sections_url:window.location.pathname})})).json();this.renderContents(s)}async _clearCart(){const t=await(await fetch(`${window.routes.cart_url}/clear.js`,{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({sections:["cart-drawer","cart-icon-bubble"],sections_url:window.location.pathname})})).json();this.renderContents(t)}getSectionInnerHTML(e,t=".shopify-section"){return new DOMParser().parseFromString(e,"text/html").querySelector(t).innerHTML}getSectionsToRender(){return[{id:"cart-drawer",selector:"#CartDrawer"},{id:"cart-icon-bubble"}]}getSectionDOM(e,t=".shopify-section"){return new DOMParser().parseFromString(e,"text/html").querySelector(t)}setActiveElement(e){this.activeElement=e}}customElements.define("cart-drawer",CartDrawer);class CartDrawerItems extends CartItems{onChange(e){e.target.closest("bcw-cart-upsells")||super.onChange(e)}enableLoading(e){super.enableLoading(e);const t=this.querySelector(`#CartDrawer-Item-${e}`);t&&t.classList.add("is-loading")}disableLoading(e){super.disableLoading(e);const t=this.querySelector(`#CartDrawer-Item-${e}`);t&&t.classList.remove("is-loading")}getSectionsToRender(){return[{id:"CartDrawer",section:"cart-drawer",selector:".drawer__inner"},{id:"cart-icon-bubble",section:"cart-icon-bubble",selector:".shopify-section"}]}}customElements.define("cart-drawer-items",CartDrawerItems);


/* ============================================================================
   BCW PROMO GIFTS — USA SALE 24-28.09.2026 (Aseo24, 23.09.2026)
   Dopisek, nie zmiana istniejacego kodu. Aktywuje sie WYLACZNIE gdy <cart-drawer>
   ma atrybuty data-gifts / data-tiers (ustawia je bcw-cart-drawer.liquid tylko
   w oknie promocji). Bez nich kazda metoda oddaje sterowanie oryginalowi.

   Roznice wzgledem oryginalu:
   - dowolna liczba progow (tu 4) zamiast dwoch,
   - kilka gratisow na jednym progu (ili + Cleanser przy 400 $),
   - prog liczony z pozycji NIE bedacych gratisami i PRZED rabatami
     (original_line_price), bo rabat 15/20 % zbija cart.total_price i inaczej
     drawer nie dodalby gratisu, ktory walidacja serwerowa juz dopuszcza,
   - grupa "wybierz jeden" (worek wosku) — nie auto-dodaje, pokazuje wybor.
   ========================================================================== */
(function () {
  if (typeof CartDrawer !== 'function') return;
  var P = CartDrawer.prototype;
  var origSync = P.syncFreeGift;
  var origProgress = P.updateProgressBar;
  var origConnected = P.connectedCallback;

  function attrJSON(el, name) {
    try {
      var raw = el.dataset[name];
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      console.error('BCW promo: zly JSON w data-' + name, e);
      return null;
    }
  }

  P._bcwGroups = function () {
    if (this._bcwGroupsCache === undefined) {
      var g = attrJSON(this, 'gifts');
      this._bcwGroupsCache = Array.isArray(g) && g.length ? g : null;
    }
    return this._bcwGroupsCache;
  };

  P._bcwTiers = function () {
    if (this._bcwTiersCache === undefined) {
      var t = attrJSON(this, 'tiers');
      this._bcwTiersCache = Array.isArray(t) && t.length ? t : null;
    }
    return this._bcwTiersCache;
  };

  P._bcwRate = function () {
    var r = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1');
    return r > 0 ? r : 1;
  };

  P._bcwGiftIds = function (groups) {
    var ids = {};
    groups.forEach(function (g) {
      (g.v || []).forEach(function (v) { ids[v.id] = true; });
    });
    return ids;
  };

  /* Suma pozycji platnych, przed rabatami — tak samo liczy walidacja serwerowa. */
  P._bcwPaidSubtotal = function (cart, groups) {
    var giftIds = this._bcwGiftIds(groups);
    return (cart.items || []).reduce(function (sum, item) {
      if (giftIds[item.variant_id]) return sum;
      var line = typeof item.original_line_price === 'number' ? item.original_line_price : item.line_price;
      return sum + (line || 0);
    }, 0);
  };

  P._bcwUnlocked = function (group, paid, rate) {
    return group.t > 0 ? paid >= group.t * rate : true;
  };

  /* Wlasne dodanie gratisu: zwraca true/false zamiast polykac blad.
     Oryginalne _addGift przy 422 (brak stanu, produkt nieopublikowany) nic nie
     robi i nie sygnalizuje porazki — przez to petla progow zatrzymywala sie na
     pierwszym niedostepnym gratisie i kolejne nigdy nie byly dodawane. */
  P._bcwAddGift = async function (variantId, tag) {
    try {
      var res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: { _bcw_gift: tag },
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });
      var data = await res.json();
      if (!res.ok || data.status === 422) {
        console.warn('BCW promo: gratis ' + variantId + ' niedostepny —', data.description || data.message || res.status);
        return false;
      }
      this.renderContents(data);
      return true;
    } catch (e) {
      console.error('BCW promo add gift:', e);
      return false;
    }
  };

  P.syncFreeGift = async function () {
    var groups = this._bcwGroups();
    if (!groups) return origSync.call(this);
    if (this._giftSyncing) return;
    this._giftSyncing = true;
    try {
      var cart = await fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); });
      if (cart.items.length > 0 && cart.total_price === 0) {
        await this._clearCart();
        return;
      }
      var rate = this._bcwRate();
      var paid = this._bcwPaidSubtotal(cart, groups);
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        var ids = (g.v || []).map(function (v) { return v.id; });
        var inCart = (cart.items || []).filter(function (it) { return ids.indexOf(it.variant_id) > -1; });
        var unlocked = this._bcwUnlocked(g, paid, rate);
        var tag = g.k || 'bcw_promo';

        if (!unlocked && inCart.length) { await this._removeGift(inCart[0].key); return; }
        if (unlocked && inCart.length > 1) { await this._removeGift(inCart[inCart.length - 1].key); return; }
        if (unlocked && inCart.length === 1 && inCart[0].quantity > 1) { await this._setGiftQty(inCart[0].key, 1); return; }
        if (unlocked && !inCart.length && !g.c && cart.item_count > 0) {
          var added = await this._bcwAddGift(ids[0], tag);
          if (added) return;
          /* nie udalo sie (brak stanu / produkt nieopublikowany) — idziemy dalej,
             zeby jeden zepsuty gratis nie zablokowal pozostalych progow */
          continue;
        }
      }
      this._bcwRenderPicker(cart, groups, paid, rate);
    } catch (e) {
      console.error('BCW promo gift sync:', e);
    } finally {
      this._giftSyncing = false;
    }
  };

  /* Wybor jednego gratisu z grupy (worek wosku) — bez auto-dodania. */
  P._bcwRenderPicker = function (cart, groups, paid, rate) {
    var box = this.querySelector('[data-bcw-gift-picker]');
    if (!box) return;
    var html = '';
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      if (!g.c) continue;
      if (!this._bcwUnlocked(g, paid, rate)) continue;
      var ids = (g.v || []).map(function (v) { return v.id; });
      var already = (cart.items || []).some(function (it) { return ids.indexOf(it.variant_id) > -1; });
      if (already) continue;
      var tag = g.k || 'bcw_promo';
      html +=
        '<p class="bcw-gift-picker__title">' + (g.l || 'Choose your free gift') + '</p>' +
        '<div class="bcw-gift-picker__opts">' +
        (g.v || [])
          .map(function (v) {
            return (
              '<button type="button" class="bcw-gift-picker__btn" data-bcw-variant="' +
              v.id + '" data-bcw-tag="' + tag + '">' + v.n + '</button>'
            );
          })
          .join('') +
        '</div>';
    }
    box.innerHTML = html;
    box.hidden = !html;
  };

  /* Uwaga: <cart-drawer> jest ulepszany (customElements.define) na poczatku tego pliku,
     ZANIM ten blok podmieni metody — dlatego connectedCallback w klasie odklada pierwsza
     synchronizacje przez setTimeout, a wiazanie klikniec robimy tez dla juz istniejacych
     elementow (na dole bloku). */
  function bindPicker(el) {
    if (!el || el._bcwPickerBound) return;
    el._bcwPickerBound = true;
    var self = el;
    el.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest ? ev.target.closest('.bcw-gift-picker__btn') : null;
      if (!btn || btn.disabled) return;
      ev.preventDefault();
      btn.disabled = true;
      btn.classList.add('is-loading');
      var id = parseInt(btn.dataset.bcwVariant, 10);
      if (!id) return;
      self._bcwAddGift(id, btn.dataset.bcwTag || 'bcw_promo').then(function (ok) {
        if (ok) return;
        /* brak stanu — nie zostawiaj klientowi martwego przycisku */
        btn.disabled = true;
        btn.classList.remove('is-loading');
        btn.classList.add('is-soldout');
        btn.textContent = btn.textContent + ' — sold out';
      });
    });
  }

  P.connectedCallback = function () {
    origConnected.call(this);
    bindPicker(this);
  };

  P.updateProgressBar = async function () {
    var tiers = this._bcwTiers();
    var groups = this._bcwGroups();
    if (!tiers || !groups) return origProgress.call(this);
    try {
      var cart = await fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); });
      var rate = this._bcwRate();
      var paid = this._bcwPaidSubtotal(cart, groups);
      var from = 0;
      for (var i = 0; i < tiers.length; i++) {
        var to = tiers[i].t * rate;
        this._updateSegment('t' + i, from, to, paid);
        from = to;
      }
      this._updateStatus(
        paid,
        tiers.map(function (x) { return { threshold: x.t * rate, label: x.l }; })
      );
    } catch (e) {
      console.error('BCW promo progress bar:', e);
    }
  };

  /* elementy juz obecne w DOM (ulepszone przed podmiana metod) */
  var existing = document.querySelectorAll('cart-drawer');
  for (var i = 0; i < existing.length; i++) bindPicker(existing[i]);
})();


/* ============================================================================
   BCW GIFT-SAFE QUANTITY UPDATE (Aseo24, 23.09.2026)
   Problem: walidacja gratisow (app bcw-gift-rules i stara bcw-gift-guard) dziala
   takze na /cart/change.js. Gdy klient zmniejsza ilosc / usuwa produkt i suma
   spada ponizej progu gratisu, Shopify ODRZUCA zmiane (422), a CartItems pokazuje
   ogolny blad "There was an error..." — klient nie moze zmniejszyc koszyka.
   Rozwiazanie: przy ZMNIEJSZENIU ilosci platnej pozycji liczymy sume po zmianie;
   jesli ktorys gratis przestaje przyslugiwac, wysylamy JEDNO zadanie /cart/update.js
   (nowa ilosc + usuniecie tych gratisow), wiec koszyk po zmianie jest poprawny.
   Progi: w promocji z data-gifts, poza nia z data-gift/gift2 (szpatulka, ili).
   We wszystkich innych przypadkach dziala oryginalne updateQuantity bez zmian.
   ========================================================================== */
(function () {
  if (typeof CartItems !== 'function') return;
  var P = CartItems.prototype;
  if (P._bcwGiftSafe) return;
  P._bcwGiftSafe = true;
  var orig = P.updateQuantity;

  function giftRules() {
    var d = document.querySelector('cart-drawer');
    if (!d) return null;
    var rules = {};
    var groups = null;
    try { groups = d.dataset.gifts ? JSON.parse(d.dataset.gifts) : null; } catch (e) { groups = null; }
    if (Array.isArray(groups) && groups.length) {
      groups.forEach(function (g) {
        (g.v || []).forEach(function (v) { rules[v.id] = parseInt(g.t || 0, 10); });
      });
      return rules;
    }
    var a = parseInt(d.dataset.giftVariantId, 10);
    var b = parseInt(d.dataset.gift2VariantId, 10);
    if (a) rules[a] = parseInt(d.dataset.giftThreshold || '0', 10);
    if (b) rules[b] = parseInt(d.dataset.gift2Threshold || '0', 10);
    return Object.keys(rules).length ? rules : null;
  }

  function isGift(item) {
    return /-free$/i.test(item.sku || '') || !!(item.properties && item.properties._bcw_gift);
  }

  P.updateQuantity = function (line, quantity) {
    var self = this;
    var args = arguments;
    var rules = giftRules();
    var newQty = parseInt(quantity, 10);
    if (!rules || isNaN(newQty)) return orig.apply(self, args);

    fetch(window.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var idx = parseInt(line, 10) - 1;
        var target = cart.items[idx];
        if (!target || isGift(target) || newQty >= target.quantity) return orig.apply(self, args);

        var rate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1') || 1;
        var paid = 0;
        cart.items.forEach(function (it, i) {
          if (isGift(it)) return;
          var q = i === idx ? newQty : it.quantity;
          paid += (typeof it.original_price === 'number' ? it.original_price : it.price) * q;
        });

        var updates = {};
        var drop = false;
        cart.items.forEach(function (it) {
          if (!isGift(it)) return;
          var t = rules[it.variant_id];
          if (t === undefined) return;
          if (paid < t * rate) { updates[it.key] = 0; drop = true; }
        });
        if (!drop) return orig.apply(self, args);

        updates[target.key] = newQty;
        return self._bcwBulkUpdate(line, updates);
      })
      .catch(function (e) {
        console.error('BCW gift-safe precheck:', e);
        orig.apply(self, args);
      });
  };

  P._bcwBulkUpdate = function (line, updates) {
    var self = this;
    self.enableLoading(line);
    var sections = self.getSectionsToRender();
    var body = JSON.stringify({
      updates: updates,
      sections: sections.map(function (s) { return s.section; }),
      sections_url: window.location.pathname
    });
    var cfg = fetchConfig();
    cfg.body = body;
    return fetch(window.routes.cart_update_url, cfg)
      .then(function (r) { return r.json(); })
      .then(function (n) {
        if (!n || n.status || !n.sections) throw new Error((n && (n.description || n.message)) || 'update failed');
        self.classList.toggle('is-empty', n.item_count === 0);
        var drawer = document.querySelector('cart-drawer');
        var footer = document.getElementById('main-cart-footer');
        if (footer) footer.classList.toggle('is-empty', n.item_count === 0);
        if (drawer) drawer.classList.toggle('is-empty', n.item_count === 0);
        sections.forEach(function (o) {
          var host = document.getElementById(o.id);
          if (!host || !n.sections[o.section]) return;
          var el = host.querySelector(o.selector) || host;
          el.innerHTML = self.getSectionInnerHTML(n.sections[o.section], o.selector);
        });
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: n });
        }
      })
      .catch(function (e) {
        console.error('BCW gift-safe update:', e);
        var box = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (box && window.cartStrings) box.textContent = window.cartStrings.error;
      })
      .finally(function () { self.disableLoading(line); });
  };
})();
